









































import DocumentLink from '@/components/DocumentLink'

export default {
    name: 'IconBox'

    components: 
        DocumentLink: DocumentLink

    data: -> fields: @defaultFields

    computed:
        isDark: -> false #@$parent.isDark
        isSmall: -> @$parent.smallBoxes
        iconClass: ->
            'uk-text-white uk-background-primary': !@isDark
            'uk-text-emphasis uk-background-white': @isDark

    methods:
        defaultFields: ->
            icon: []
            title: []
            text: []
            button_title: []
            button_link: []

        setContent: (document) ->
            fields =
                icon: document.icon
                title: document.title
                text: document.text
                button_title: document.button_title
                button_link: document.button_link
            $.extend @fields, fields

    created: ->
        @setContent @$attrs.document

}
